'use client';
import { useState } from 'react';
import { useResetPassword } from '@/utils/react-query-hooks';
import Anchor from '@shared-ui/components/Anchor';
import Input from 'src/components/forms/Input';
// import { Email } from '@/components/presentational/tailwind/Auth/Email';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState<string | undefined>(undefined);
  const magicLinkMutation = useResetPassword({
    onSuccess: () => {
      setSuccessMessage('A magic link has been sent to your email!');
    },
  });

  return (
    <>
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-medium">Reset password</h1>
        <p className="mx-auto text-sm max-w-72 text-neutral-500">
          Enter your email to receive a magic link to reset your password.
        </p>
      </div>

      <form className="mt-8 space-y-4">
        <Input id="email" label="Email Address" placeholder="Enter email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className="relative w-full p-px rounded-full h-9 bg-btn-gradient shadow-btn-outline-stroke" type="button"
          onClick={() => {
            magicLinkMutation.mutate({
              email: email,
            });
          }}
        >
          <span className="block font-medium text-white rounded-full bg-turquoise-medium size-full text-sm/8">
            Reset Password
          </span>
        </button>
      </form>

      <Anchor href="/login" className="absolute top-0 left-0 inline-flex items-center space-x-3">
        <span className="flex items-center justify-center border rounded-full size-6 border-neutral-200">
          <svg className="size-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.6666 7.99992H3.33325M3.33325 7.99992L7.99992 12.6666M3.33325 7.99992L7.99992 3.33325"
              stroke="#0F0F0F"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span className="text-sm font-medium text-neutral-600">Back</span>
      </Anchor>
    </>
    // <div className="container grid items-center h-full max-w-lg mx-auto overflow-auto overflow-visible text-left">
    //   <div className="space-y-8 ">
    //     <div className="space-y-2 ">
    //       <h1 className="mt-10 mb-3 text-3xl font-bold text-center text-gray-900 sm:text-4xl lg:mt-5 lg:text-left xl:mt-5 xl:text-5xl">Reset password</h1>
    //       <p className="max-w-sm text-center text-gray-400 text-md sm:text-left">
    //         Enter your email to receive a magic link to reset your password.
    //       </p>
    //     </div>

    //     <Email
    //       successMessage={successMessage}
    //       isLoading={magicLinkMutation.isLoading}
    //       view="forgot-password"
    //       onSubmit={(email) => {
    //         magicLinkMutation.mutate({
    //           email,
    //         });
    //       }}
    //     />
    //   </div>
    // </div>
  );
}
